import * as Yup from 'yup';

const createProjectValidationSchema = Yup.object().shape({
  totalExpenditure: Yup.number().required('formControl.validation.required'),
  expenditureFromVNU: Yup.string().required('formControl.validation.required'),
  fixedExpenditure: Yup.string().required('formControl.validation.required'),
  flexibleExpenditure: Yup.string().required('formControl.validation.required'),
  expenditureFromFunding: Yup.string().required('formControl.validation.required'),
  projectCode: Yup.string().nullable().required('formControl.validation.required'),
  topicCode: Yup.string().nullable().required('formControl.validation.required'),
  startDate: Yup.string().nullable().required('formControl.validation.required'),
  endDate: Yup.string().nullable().required('formControl.validation.required'),
});

export const createFinancialAdjustmentSchema = Yup.object().shape({
  commitment: Yup.string().required('formControl.validation.required'),
  otherExpenditure: Yup.number().min(0),
  financialAdjustmentItems: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required('formControl.validation.required'),
      expenditureTypeId: Yup.string().required('formControl.validation.required'),
      beforeExpenditureFromVNUHCM: Yup.number().min(0),
      beforeExpenditureFromFunding: Yup.number().min(0),
      afterExpenditureFromVNUHCM: Yup.number().required('formControl.validation.required'),
      afterExpenditureFromFunding: Yup.number().required('formControl.validation.required'),
      reason: Yup.string().test(
        'is-change',
        'formControl.validation.noReasonInExpenditure',
        // eslint-disable-next-line func-names
        function (value) {
          const {
            beforeExpenditureFromVNUHCM,
            beforeExpenditureFromFunding,
            afterExpenditureFromVNUHCM,
            afterExpenditureFromFunding,
            expenditureTypeId,
          } = this.parent;

          return expenditureTypeId === '2aafiog2-b23h-9753-54it-d436e1d4e880'
            ? true
            : (beforeExpenditureFromVNUHCM === afterExpenditureFromVNUHCM || value !== '') &&
                (beforeExpenditureFromFunding === afterExpenditureFromFunding || value !== '');
        }
      ),
    })
  ),
});

export const liquidationSchema = Yup.object().shape({
  liquidationDate: Yup.string().required('formControl.validation.required'),
  code: Yup.string().required('formControl.validation.required'),
  liquidationDecisionFile: Yup.mixed().required('formControl.validation.required'),
});

export const createSummaryReportReviewSchema = Yup.object().shape({
  comment: Yup.string().required('formControl.validation.required'),
  deadline: Yup.string()
    .nullable()
    .test('is-valid-date', 'formControl.validation.canNotLessThanDateNow', (value) => {
      if (!value) return true;
      return new Date(value).getTime() > new Date().getTime();
    }),
});

export const adjustmentCommentsSchema = Yup.object().shape({
  comment: Yup.string().required('formControl.validation.required'),
});

export const adjustmentRejectSchema = Yup.object().shape({
  rejectionReason: Yup.string().required('formControl.validation.required'),
});

export const registerResultCommentsSchema = Yup.object().shape({
  comment: Yup.string().required('formControl.validation.required'),
});

export const registerResultRejectSchema = Yup.object().shape({
  rejectReason: Yup.string().required('formControl.validation.required'),
});

export default createProjectValidationSchema;
